import { getMessages } from 'app/store/constants';

export const NAVIGATION_PANEL_DASHBOARD_ACTION_CLASS = 'navigation-panel__dashboard-action';
export const TOOLTIP_CLOSE_BOARD = getMessages().getText('nav_panel.boards.close');
export const TOOLTIP_CURRENT_BOARD = getMessages().getText('nav_panel.boards.current');
export const TOOLTIP_BOARD_SWITCH = getMessages().getText('nav_panel.boards.switch');
export const TOOLTIP_BOARD_ARCHIVED = getMessages().getText('recent_panel.boards.archived');
export const NAVIGATION_PANEL_HINT = getMessages().getText('hint.board_scroll');
export const NAVIGATION_PANEL_STARRED_HINT_FIRST = getMessages().getText('hint.nav_panel_starred_first');
export const NAVIGATION_PANEL_STARRED_HINT_SECOND = getMessages().getText('hint.nav_panel_starred_second');
